import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { AuthProvider } from "./lib/auth";
import "./index.css";

// Suppress the harmless "ResizeObserver loop completed with undelivered
// notifications" warning. It fires whenever an observed element triggers
// another layout in the same frame — common with Tailwind transitions, the
// wheel picker, and chart libraries. Chrome treats it as an error event but
// it doesn't affect behavior. Hiding it keeps DevTools clean for beta
// testers + screen recordings.
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    if (event.message && /ResizeObserver loop/.test(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
